var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_547_1924)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 10,
    width: 44,
    height: 44,
    rx: 6,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.2491 23.4245H46.876C47.4311 24.2665 47.8373 25.1916 48.0804 26.1675H50.9854V39.0296H42.2717V36.8616C41.7588 37.0366 41.2289 37.1656 40.6868 37.2453V41.2547C40.6868 42.536 41.7257 43.5749 43.0079 43.5749H50.2491C51.5304 43.5749 52.5693 42.5359 52.5693 41.2547V25.7457C52.5693 24.4633 51.5303 23.4245 50.2491 23.4245ZM46.6286 42.5019C45.9722 42.5019 45.4394 41.969 45.4394 41.3127C45.4394 40.6546 45.9722 40.1226 46.6286 40.1226C47.2858 40.1226 47.8186 40.6546 47.8186 41.3127C47.8186 41.969 47.2858 42.5019 46.6286 42.5019ZM42.7594 35.6636C44.4868 36.3855 46.0818 36.5255 46.0997 36.5334C46.1181 36.5352 46.1354 36.5352 46.1544 36.5352C46.371 36.5352 46.5696 36.4238 46.6429 36.2531C46.7235 36.0676 46.6362 35.8631 46.4336 35.7581C45.8282 35.4493 45.2194 34.7233 44.8882 34.0438C46.3711 32.6027 47.2926 30.5871 47.2926 28.3561C47.2926 23.9759 43.7418 20.4251 39.3616 20.4251C34.9815 20.4251 31.4307 23.9759 31.4307 28.3561C31.4307 32.7362 34.9815 36.287 39.3616 36.287C40.5164 36.287 41.6134 36.04 42.603 35.5963C42.6552 35.619 42.7074 35.6418 42.7594 35.6636ZM35.2509 30.2564C34.8081 30.2564 34.376 30.1415 34.1682 30.0321L34.3542 29.2175C34.5784 29.3322 34.9392 29.447 35.3111 29.447C35.6501 29.447 35.8141 29.3322 35.8141 29.1463C35.8141 28.9659 35.6501 28.8675 35.2346 28.7254C34.6112 28.5011 34.1955 28.1621 34.1955 27.6153C34.1955 26.9646 34.7478 26.4615 35.6774 26.4615C36.1148 26.4615 36.4321 26.5435 36.6726 26.6474L36.4648 27.4402C36.3063 27.3693 36.0329 27.2654 35.6664 27.2654C35.3657 27.2654 35.2017 27.3748 35.2017 27.5387C35.2017 27.7248 35.3985 27.7957 35.8633 27.9708C36.5249 28.2169 36.8202 28.5668 36.8202 29.0807C36.8203 29.7151 36.3281 30.2564 35.2509 30.2564ZM40.4864 30.2017L40.4426 28.8783C40.4261 28.4629 40.4206 27.9708 40.4206 27.3965H40.4043C40.2895 27.8832 40.1364 28.4354 40.0161 28.8401L39.6497 30.1253H38.8787L38.5724 28.8401C38.474 28.4465 38.3647 27.8997 38.2772 27.3965H38.2663C38.2443 27.9161 38.228 28.4629 38.2116 28.8783L38.1514 30.2017H37.2438L37.4733 26.5162H38.8021L39.0427 27.5114C39.1465 27.9161 39.2559 28.4082 39.3325 28.8565H39.3489C39.4528 28.4082 39.5731 27.8886 39.6825 27.5004L39.9614 26.5162H41.2573L41.4433 30.2016L40.4864 30.2017ZM42.9904 28.7254C42.3671 28.5011 41.9514 28.1621 41.9514 27.6153C41.9514 26.9646 42.5037 26.4615 43.4333 26.4615C43.8707 26.4615 44.1879 26.5435 44.4284 26.6474L44.2206 27.4402C44.0621 27.3693 43.7887 27.2654 43.4223 27.2654C43.1215 27.2654 42.9575 27.3748 42.9575 27.5387C42.9575 27.7248 43.1543 27.7957 43.6191 27.9708C44.2808 28.2169 44.5761 28.5668 44.5761 29.0807C44.5761 29.7151 44.084 30.2564 43.0067 30.2564C42.5639 30.2564 42.1318 30.1415 41.924 30.0321L42.11 29.2175C42.3342 29.3322 42.695 29.4471 43.0669 29.4471C43.4059 29.4471 43.5699 29.3322 43.5699 29.1463C43.57 28.9659 43.406 28.8675 42.9904 28.7254Z",
    fill: "#043293"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_547_1924",
    x: 0,
    y: 0,
    width: 84,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_547_1924"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_547_1924",
    result: "effect2_dropShadow_547_1924"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_547_1924",
    result: "effect3_dropShadow_547_1924"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_547_1924",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.91a2b70bd110b824c312281a4b9228f0.svg";
export { ForwardRef as ReactComponent };